import React from "react";

import RiskGraph from "../../components/risk-line-graph";
import {
  getPercentileText2,
} from "../../utils/results";

const ChartConfig = require(
  "../../../json/ostp-config.json",
);

export const Mars_KOsteoResults = ({
  result = {},
  userName,
  nameEndsWithS,
}) => {
  const { percentile_to_SD: percentileToSD } =
    ChartConfig.setupData;

  const percentile = Number(result.percentile);

  const hasResult =
    Object.prototype.hasOwnProperty.call(
      result,
      "value",
    ) && result.value !== null;

  const hasValidPercentile =
    Number.isInteger(percentile) &&
    percentile >= 1 &&
    percentile <= percentileToSD.length;

  if (!hasResult || !hasValidPercentile) {
    return null;
  }

  /*
   * Preserve the original component behavior:
   * adjusted_result must be truthy to use the adjusted
   * graph. A value of 0 uses the raw graph.
   */
  const usesAdjustedGraph = Boolean(
    result.adjusted_result,
  );

  const standardDeviation =
    percentileToSD[percentile - 1];

  if (!Number.isFinite(standardDeviation)) {
    return null;
  }

  const oddsRatio = 1.6;

  const diseaseRisk = Math.pow(
    oddsRatio,
    standardDeviation,
  );

  if (!Number.isFinite(diseaseRisk)) {
    return null;
  }

  const percentileText =
    getPercentileText2(percentile);

  const graphKey = usesAdjustedGraph
    ? "results-adjusted-Mars_KOsteo-histogram"
    : "results-Mars_KOsteo-histogram";

  return (
    <div>
      <div className="title-margins">
        <h2>
          {userName
            ? `${userName}'${nameEndsWithS ? "" : "s"}`
            : ""}{" "}
          Results for Knee Osteoarthritis
        </h2>

        <h5>
          [
          <a href="https://pubmed.ncbi.nlm.nih.gov/36347255/">
            Mars et al. (2022)
          </a>
          ]
        </h5>
      </div>

      <div className="title-break">
        <span>Your Results</span>
      </div>

      <div className="card">
        <p>
          To use the graph, find the dot on the line that
          shows your genetic score. The grey histogram shows
          the number of people and their genetic scores. The
          bin containing your score tells how many other
          people have a score like yours. If your score is on
          the{" "}
          <strong>right side of the histogram</strong>, you
          will tend to have a higher risk for knee
          osteoarthritis.
          {usesAdjustedGraph
            ? " Your score is comprised of both the genetic and clinical risk factor results."
            : ""}
        </p>

        <RiskGraph
          graphType="risk"
          percentile={percentile}
          crmKey={graphKey}
        />

        <br />

        <p>
          You are in the <b>{percentileText}</b> and your
          risk for knee osteoarthritis is{" "}
          <b>{diseaseRisk.toPrecision(2)}</b> fold compared
          to the average.
          {usesAdjustedGraph
            ? " Your height, sex, age and weight have been factored in to your score to better predict your risk for knee osteoarthritis."
            : ""}
        </p>
      </div>

      <div className="title-break">
        <span>Comments</span>
      </div>

      <div className="card">
        <p>
          This study developed a polygenic risk score for
          knee osteoarthritis that includes 1,052,275
          variants based on 306,418 individuals (24,955
          cases).
        </p>

        <p>
          The study was limited to individuals of European
          ancestry. It is not clear how well the PRS score
          performs for other ancestries.
        </p>
      </div>
    </div>
  );
};

export default Mars_KOsteoResults;